export default __webpack_public_path__ + "static/media/mas.f595f52c.png";